 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A0_COVER from '@/components/00_cover'
 import LOVE_1 from '@/components/love_1'
 import A1_PRAISE from '@/components/01_praise'
 import A2_ALSOBY from '@/components/02_alsoby'
 import A3_TITLE from '@/components/03_title'
 import A4_COPYRIGHT from '@/components/04_copyright'
 import A5_DEDICATION from '@/components/05_dedication'
 import A6_EPIGRAPH from '@/components/06_epigraph'
 import A7_CONTENTS from '@/components/07_contents'
 import A8_AFIRSTTHING from '@/components/08_afirstthing'
 import A9_APREVIEW from '@/components/09_apreview'
 import A0_SACREDSPIRAL from '@/components/10_sacredspiral'
 import A1_LOOPONE from '@/components/11_loopone'
 import A2_LOOPTWO from '@/components/12_looptwo'
 import A3_LOOPTHREE from '@/components/13_loopthree'
 import A4_LOOPFOUR from '@/components/14_loopfour'
 import A5_LOOPFIVE from '@/components/15_loopfive'
 import A6_LOOPSIX from '@/components/16_loopsix'
 import A7_LOOPSEVEN from '@/components/17_loopseven'
 import A8_ALASTTHING from '@/components/18_alastthing'
 import LOVE_2 from '@/components/love_2'
 import A9_ACKNOWLEDGMENTS from '@/components/19_acknowledgments'
 import A0_BIBLIOGRAPHY from '@/components/20_bibliography'
 import A1_RESOURCES from '@/components/21_resources'
 import A2_CREDITS from '@/components/22_credits'
 import A3_ABOUTTHEAUTHOR from '@/components/23_abouttheauthor'
 import A4_TOOURREADERS from '@/components/24_toourreaders'
 import A5_BACKCOVER from '@/components/25_backcover'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/07_contents",
 			"name" : "07_contents",
 			"component" : A7_CONTENTS
 		},
 		{
 			"path" : "/08_afirstthing",
 			"name" : "08_afirstthing",
 			"component" : A8_AFIRSTTHING
 		},
 		{
 			"path" : "/09_apreview",
 			"name" : "09_apreview",
 			"component" : A9_APREVIEW
 		},
 		{
 			"path" : "/10_sacredspiral",
 			"name" : "10_sacredspiral",
 			"component" : A0_SACREDSPIRAL
 		},
 		{
 			"path" : "/11_loopone",
 			"name" : "11_loopone",
 			"component" : A1_LOOPONE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js